import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useApp } from "@/context/AppContext";
import { Heart, X } from "lucide-react";
import { Link } from "react-router-dom";

export default function WishlistSheet({ open, onOpenChange }) {
  const { wishlist, toggleWishlist } = useApp();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-md p-0 flex flex-col" data-testid="wishlist-sheet">
        <SheetHeader className="px-6 pt-6 pb-4 border-b border-slate-100">
          <SheetTitle className="font-display text-xl">Your Wishlist ({wishlist.length})</SheetTitle>
        </SheetHeader>
        {wishlist.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center px-6 text-center gap-3">
            <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center">
              <Heart className="w-7 h-7 text-amber-600" />
            </div>
            <div className="font-display text-lg font-semibold">Wishlist khaali hai</div>
            <p className="text-sm text-slate-500 max-w-xs">Tap the heart icon on any product to save it here.</p>
          </div>
        ) : (
          <div className="flex-1 overflow-y-auto px-6 py-4 space-y-3">
            {wishlist.map((item) => (
              <div key={item.id} className="flex gap-3 border border-slate-100 rounded-2xl p-3" data-testid={`wishlist-item-${item.id}`}>
                <Link to={`/product/${item.id}`} onClick={() => onOpenChange(false)} className="flex-shrink-0">
                  <img src={item.image} alt={item.name} className="w-20 h-20 rounded-xl object-cover" />
                </Link>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-slate-900 truncate">{item.name}</div>
                  <div className="text-xs text-slate-500 truncate">{item.shop_name}</div>
                  <div className="flex items-center gap-2 mt-1">
                    <div className="text-sm font-bold text-emerald-800">₹{item.price}</div>
                    {item.mrp > item.price && <div className="text-xs text-slate-400 line-through">₹{item.mrp}</div>}
                  </div>
                </div>
                <button onClick={() => toggleWishlist(item)} className="text-slate-400 hover:text-red-500 self-start p-1" aria-label="Remove" data-testid={`wishlist-remove-${item.id}`}>
                  <X className="w-4 h-4" />
                </button>
              </div>
            ))}
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
